import React from 'react';
import '../customRadioButton.css';
import { Box } from '@mui/material';
import { useState } from 'react';
import { ChildCare } from '@mui/icons-material';

const CustomRadioBox = ({ id, name, label, children , project, component, height, selectedValue, setSelectedValue, onBlur, onFocus, errorFlag, errorMsg, setPageData, value, pageData, onChange, width}) => {


  const handleRadioChange = (event) => {
    setSelectedValue(event.target.value)
    setPageData((last) => {
      return { ...last, project_type_id: event.target.value };
  });
    // console.log(event.target.value)
  };
// console.log(pageData)

  return (
    <>
      <input onFocus={onFocus} onBlur={onBlur} checked={selectedValue === value} className='radio-input' id={id} value={label} name={name} type='radio' onChange={onChange} style={{display:'none'}}/>
      <label htmlFor={id} label={label}>
        <Box className='custom-radio'  sx={{width:width ? width : '300px', backgroundColor:'#fff', border: '1px solid #08231B', borderRadius:'10px', height: height, position:'relative', boxShadow: selectedValue === label ? '0px 0px 20px #00D744' : 'none', cursor:'pointer'}}>
          <Box className='flex a-center j-center' sx={{width:'20px', height:'20px', border: '1px solid #08231B', borderRadius:'50%', position:'absolute', top:10, left:10}}>
            {selectedValue === label  ? <Box sx={{width:'14px', height:'14px', borderRadius:'50%',backgroundColor:'#08231B'}}></Box> : null}
          </Box>
          <Box sx={{width:'100%',height:'100%', display:'flex', justifyContent:'center', alignItems:'center'}}>
            {component} 
          </Box>
        </Box>
      </label>
    </>
  );
};

export default CustomRadioBox;